import { render } from "./CreateTypeService.vue?vue&type=template&id=6bb208b6&scoped=true"
import script from "./CreateTypeService.vue?vue&type=script&lang=js"
export * from "./CreateTypeService.vue?vue&type=script&lang=js"

import "./CreateTypeService.vue?vue&type=style&index=0&id=6bb208b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb208b6"]])

export default __exports__